import { createSlice } from "@reduxjs/toolkit";
import apiManagerRoom from "api/manager-meeting";
import { SLICE_NAME } from "constants/common";
import moment from "moment";
import { setShowBackdrop } from "store/commonSlice";
import store from "store/store";

export const fetchData = async (data) => {
    try {
        store.dispatch(setShowBackdrop(true))
        const res = await apiManagerRoom.getListProgressRoom(data)
        if (res.status === 200) {
            if(res.data?.detail === "NO_ROOM") {
                store.dispatch(setTableData({
                    data: [],
                    total: 0,
                    totalRoomProgressing: res.data?.totalRoomProgressing,
                    totalRoomEndDay: res.data?.totalRoomEndDay,
                    totalRoomProgressingDay: res.data?.totalRoomProgressingDay
                }))
            } else {
                let numberRoom = res.data?.filter(room => room?.totalRoomProgressingDay);
                store.dispatch(setTableData({
                    data: res.data?.filter(room => room?.roomId),
                    total: numberRoom[0]?.totalRoom,
                    totalRoomProgressing: numberRoom[0]?.totalRoomProgressing,
                    totalRoomEndDay: numberRoom[0]?.totalRoomEndDay,
                    totalRoomProgressingDay: numberRoom[0]?.totalRoomProgressingDay
                }))
            }
        } 
    } catch (err) {
        console.log("err: ", err)
    } finally {
        store.dispatch(setIsLoading(false))
        store.dispatch(setShowBackdrop(false))
    }
}

const initialState = {
    tableData: {
        data: [],
        total: 0,
        totalRoomProgressing: 0,
        totalRoomEndDay: 0,
        totalRoomProgressingDay: 0
    },
    searchQuery: {
        startTimeDay: parseInt(moment().startOf('day').valueOf() / 1000),
        room: '',
        username: ''
    },
    isLoading: false
}

export const meetingMonitorSlice = createSlice({
    name: SLICE_NAME.MEETING_MONITOR,
    initialState,
    reducers: {
        setTableData: (state, action) => void (state.tableData = action.payload),
        setSearchQuery: (state, action) => void (state.searchQuery = action.payload),
        setIsLoading: (state, action) => void(state.isLoading = action.payload)
    }
})

export const { setTableData, setSearchQuery, setIsLoading } = meetingMonitorSlice.actions
export default meetingMonitorSlice.reducer